import * as mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'
import Cookies from 'js-cookie'

// VARIABLES
const STATES = {

    // There's no way to know if you're in min ui or not unless you've seen the sizes of both states
    // for both portrait and landscape. So the first time without switching between either of the two
    // states there's no way to know which you're in (unless you use hard coded values).
    UNKNOWN_STATE: 'UNKNOWN_STATE',

    // The reason why these events are only very likely is due to the fact that ios reports resize
    // events the whole scroll in between min ui and out - the user could still be transitioning between the two
    // states. Android only fires resize as the browser completes the switch between the two modes - the user
    // will definitely be in one of the two reported states.
    IN_MIN_UI: 'IN_MIN_UI', // The user is VERY LIKELY to be in the min ui view
    OUT_MIN_UI: 'OUT_MIN_UI' // The user is VERY LIKELY to be out the min ui view
};

const INPUT_STATES = {
    UP: 'INPUT_STATE:UP',
    DOWN: 'INPUT_STATE:DOWN',
    COMPLETE: 'INPUT_STATE:COMPLETE'
};

// INIT
const state = {

    progress: 0,
    scrollingLocked: false,

    state: STATES.UNKNOWN_STATE,
    STATES: STATES,

    input_state: INPUT_STATES.UP,
    INPUT_STATES: INPUT_STATES
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}